import request from '@/utils/request'

/**
 * 根据客户类型（企业、个人）+ 客户名称模糊查询（脱敏）https://mock-test.cheweijia.com/project/10282/interface/api/492369
 * mixedType 新增的字段  如果 mixedType 是 YES   则不校验 customerType 是否为空  查询企业和个人的公共数据；
 * 如果 mixedType 不是 YES  则强校验 customerType 不为空，且必须是 1、2之间，1是个人客户、2是企业客户；
 */
export function searchByCustomerNameSensitive(data = {}) {
  return request({
    url: '/admin/v1/vehicle/customer/searchByCustomerName/sensitive',
    method: 'POST',
    data,
  })
}

// 根据客户类型（企业、个人）+ 客户名称模糊查询
export function searchByCustomerName(data = {}) {
  return request({
    url: '/admin/v1/vehicle/customer/searchByCustomerName',
    method: 'POST',
    data,
  })
}

// 根据客户类型（企业、个人）+ 客户电话精准查询
export function searchByCustomerPhone(data = {}) {
  return request({
    url: '/admin/v1/vehicle/customer/searchByMobile',
    method: 'POST',
    data,
  })
}

// 企业客户列表查询接口
export function getEnterpriseCustomerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/list',
    method: 'POST',
    data,
  })
}

// 个人客户列表查询接口
export function getPersonalCustomerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/list/sensitive',
    method: 'POST',
    data,
  })
}

// 客户列表导出接口
export function customerExport(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/export',
    method: 'POST',
    data,
  })
}
// 客户管理新增接口
export function customerAdd(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/add',
    method: 'POST',
    data,
  })
}

// 客户管理编辑接口
export function customerEdit(data) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/edit',
    method: 'POST',
    data,
  })
}

// 客户管理详情页查看接口
export function customerExcel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/importExcel',
    method: 'POST',
    data,
  })
}

// 启用禁用状态更新接口
export function customerUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/updateState',
    method: 'POST',
    data,
  })
}

// 客户管理详情页查看接口
export function getCustomerDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/detail',
    method: 'POST',
    data,
  })
}

// 脱敏客户管理详情页查看接口
export function getCustomerDetailSensitive(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/detail/sensitive',
    method: 'POST',
    data,
  })
}

// 通过支付宝安心卡流水号查询客户信息
export function getCustomerInfoByOutRegisterId(outRegisterId) {
  return request({
    url: '/admin/v1/vehicle/customer/getDataByOutRegisterId',
    method: 'POST',
    data: {
      outRegisterId,
    },
    headers: {
      'X-Silent-Error': true,
    },
  })
}


// 改变司管时校验
export function checkDriverManagerByCustomer(id, managerId) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/checkBeforeEdit',
    method: 'POST',
    data: {
      id,
      managerId,
    },
  })
}

// 联动网约运营数据 start
// 个人客户看板-统计信息
export function getPersonSummaryInfo(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/summaryInfo',
    method: 'POST',
    data,
  })
}

// 个人客户看板-图表
export function getPersonChartInfo(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/chartInfo',
    method: 'POST',
    data,
  })
}

// 个人客户看板-租赁情况影响因子
export function getPersonRentImpactFactors(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/rentImpactFactors',
    method: 'POST',
    data,
  })
}

// 个人客户看板-网约出车情况影响因子
export function getPersonWorkImpactFactors(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/workImpactFactors',
    method: 'POST',
    data,
  })
}

// 个人客户看板-网约运营情况影响因子
export function getPersonOperateImpactFactors(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/operateImpactFactors',
    method: 'POST',
    data,
  })
}

// 个人客户运营列表
export function getPersonOperateList(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/operateList',
    method: 'POST',
    data,
  })
}

// 脱敏个人客户运营列表
export function getPersonOperateListSensitive(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/operateList/sensitive',
    method: 'POST',
    data,
  })
}

// 个人客户运营列表导出
export function exportPersonOperateList(data = {}) {
  return request({
    url: '/admin/v1/linkage/board/person/operateList/export',
    method: 'POST',
    data,
  })
}
// 联动网约运营数据 end
